import axios from "axios";
import api, { apiData } from "../utils/api";
import { serviceError } from "../lib/serviceError";
import { getAccessToken, getCustomerID, getIsLentraCustomer, getLeadID } from "../utils/storage";
import { getEnvironment } from "../utils/environment";
import { PAYMENT_GATEWAY } from "../Constants/constant";

const { API_URL, PRODUCT } = getEnvironment();
class EMIsAPI {
  // Payday EMI Loan List API
  async paydayEMILoanListAPI() {
    try {
      const req = {
        url: `loanapply/${PRODUCT}/payday_emi_loan_list_view`,
        method: "POST",
        data: {
          access_token: getAccessToken(),
          leadID: getLeadID(),
        },
      };

      const res = await apiData(req, "application/json", "php");
      return res;
    } catch (error) {
      serviceError(error);
    }
  }

  // Approval ROI View API
  async approvalROIViewAPI(values) {
    try {
      const req = {
        url: `loanapply/${PRODUCT}/v1/approval_roi_view`,
        method: "POST",
        data: {
          access_token: getAccessToken(),
          amount: values.AmountDetails.Amount,
          leadID: getLeadID(),
          productID: values.ProductID,
          step: "Repeat_Customer",
          tenure: values.TenureDetails.Tenure,
        },
      };

      const res = await apiData(req);
      return res;
    } catch (error) {
      serviceError(error);
    }
  }

  // Payday to EMI Conversion API
  async paydayToEMIConversionAPI(data) {
    try {
      const res = await axios({
        url: API_URL + "/crm/paydayToEmiConversion",
        method: "POST",
        data: {
          customer_id: getCustomerID(),
          firstDueDate: Number(localStorage.getItem("salaryDate")),
          lead_id: getLeadID(),
          loanAmtApproved: data.AmountDetails.Amount,
          productId: data.ProductID,
          roi: data.AmountDetails.ROI,
          tenure: data.TenureDetails.Tenure,
        },
        headers: {
          "Content-Type": "application/json",
          token: getAccessToken(),
        },
      });

      return res.data;
    } catch (error) {
      serviceError(error);
    }
  }

  async repaymentDataAPI() {
    const isLentra = getIsLentraCustomer() === "true";
    const endpoint = isLentra ? "/lentra/getRepaymentPageData" : "/customers/getRepaymentPageData";
    try {
      const req = {
      url: endpoint,
      method: "POST",
      data: {
        leadId: getLeadID(),
        customer: {
          customerID: getCustomerID(),
        },
      },
      headers: {
        ...(isLentra ? {} : { token: getAccessToken() }),
      },
    };
    return await apiData(req, "application/json");
    } catch (error) {
      serviceError(error);
    }
  }

  // Create Order Payment API
  async createOrderPaymentAPI(amount) {
    try {
      const endpoint = "/customers/razorpay/create-order-repayment";
      const req = {
        amount: amount,
        leadId: Number(localStorage.getItem("leadID")),
      };

      const { data } = await api.post(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Rozarpay Order Status API
  async rozarpayOrderStatusAPI() {
    try {
      const endpoint = `/customers/fetchRazorpayOrder?leadID=${getLeadID()}`;
      const req = {};

      const { data } = await api.get(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Get Repayment Amount
  async getRepaymentAmountAPI(isForeClosure) {
    const isLentra = getIsLentraCustomer() === "true";
    const url = isLentra ? "/lentra/repayment" : `loanapply/${PRODUCT}/repayment`;
    try {
      const req = {
        url,
        method: "POST",
        data: {
          leadID: getLeadID(),
          ...(!isLentra ? { access_token: getAccessToken() } : {}),
          ...(isForeClosure === false && {
          isForeClosure,
        }),
        },
      };
      if (isLentra) {
        return await apiData(req, "application/json");
      } else {
        return await apiData(req, "application/json", "php");
      }
    } catch (error) {
      serviceError(error);
    }
  }
  // Create Order Payment API
  async initiatePayment(amount) {
    try {
      const endpoint = "/payment/initiate-paymentV2";
      const req = {
        amount: Number(amount),
        leadID: Number(localStorage.getItem("leadID")),
      };

      const { data } = await api.post(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  async verifyPayment(paymentData, gateway) {
    const endpoint = gateway === PAYMENT_GATEWAY.ROZAR_PAY ? "/payment/verify-razorpay-payment" : "/payment/verify-payment";
    try {
      const { data } = await api.post(endpoint, paymentData);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  async getLentraFundIn (payload) {
    try {
      const endpoint = "/lentra/fund-in";
      const { data } = await api.post(endpoint, payload);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }
  // repayment fallback API
  async repaymentFallbackAPI(lms_id,order_id) {
    try {
      const endpoint = `/lentra/repayment-fallback?lms_id=${lms_id}&order_id=${order_id}`;
      const req = {};

      const { data } = await api.get(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
      throw error;
    }
  }

  async fetchVirtualAccount() {
    try {
      const endpoint = `/customers/virtual-account`;

      const { data } = await api.get(endpoint);
      return data;
    } catch (error) {
        serviceError(error);
        throw error;
      }
    }
  // fetch payment status API
  async fetchPaymentStatusAPI(lms_id) {
    try {
      const endpoint = `/lentra/fetch-payment-status?lms_id=${lms_id}`;
      const req = {};

      const { data } = await api.get(endpoint, req);
    return data;
    } catch (error) {
      serviceError(error);
      throw error;
    }
  }

  async generateVirtualAccount() {
    try {
      const endpoint = `/customers/virtual-account/generate`;
      const req = {
        leadID: getLeadID()
      };

      const { data } = await api.post(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
      throw error;
    }
  }

  async saveKycConsent(consent) {
    try {
      const endpoint = `/customers/kyc-consent`;
      const { data } = await api.post(endpoint, {
        "leadID": getLeadID(),
        "kycConsent": consent
      });
      return data;
    } catch (error) {
      serviceError(error);
      throw error;
    }
  }
}


export default EMIsAPI;
